import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { MARKETING_SMS_ELIGIBLE_COUNTRIES } from "@faire/web-api--source/indigofair/settings/MARKETING_SMS_ELIGIBLE_COUNTRIES";
export var getSettingMarketingSMSEligibleCountries = function() {
    return getSettingValueWithoutAssignment(MARKETING_SMS_ELIGIBLE_COUNTRIES, [
        ISO3166Alpha3.USA,
        ISO3166Alpha3.CAN
    ]);
};
